import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { CoreModule } from "../core/core.module";

import { AgmCoreModule } from "@agm/core";
import { RouterModule } from "@angular/router";
import { CouponsListingComponent } from "./coupons-listing/coupons-listing.component";
import { CouponsEditComponent } from "./coupons-edit/coupons-edit.component";
import { CouponsService } from "./services/coupons.service";

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    RouterModule
  ],
  exports: [CouponsListingComponent, CouponsEditComponent],
  providers: [CouponsService],
  declarations: [CouponsListingComponent, CouponsEditComponent]
})
export class CouponsModule {}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/coupons/coupons.module.ts